import { render, staticRenderFns } from "./VideoAnalysisMenu.vue?vue&type=template&id=df695160&scoped=true&"
import script from "./VideoAnalysisMenu.vue?vue&type=script&lang=js&"
export * from "./VideoAnalysisMenu.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnalysisMenu.vue?vue&type=style&index=0&id=df695160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df695160",
  null
  
)

export default component.exports